import OperatorsRepository from '@/js/common/Domain/Repository/Operators';
import MealsRepository from '../Repository/Meals';

import HotelOfferObjectValue from '../ObjectValue/HotelOffer';
import CheckInDateRangeFactory from './checkInDateRange/CheckInDateRange';
import CountryFactory from './Country';
import CountriesRepository from '../Repository/Countries';
import DataProxy from '../Service/DataProxy';

const HotelOfferFactory = (data, resorts) => {
    const hotelOffer = {};
    let element;
    let dateParts;
    let country;
    let resort;

    element = data.tourCriteria;
    if (typeof element !== 'undefined') {
        hotelOffer.tourCriteria = element;
    }

    element = data.cancellationPolicy;
    if (typeof element !== 'undefined') {
        hotelOffer.cancellationPolicy = element;
    }

    element = data.id;
    if (typeof element !== 'undefined') {
        hotelOffer.id = element;
    }

    element = data.sortRate;
    if (typeof element !== 'undefined') {
        hotelOffer.sortRate = element;
    }

    element = data.nights;
    if (typeof element !== 'undefined') {
        hotelOffer.nights = element;
    }

    element = data.country;
    if (typeof element !== 'undefined') {
        if (CountriesRepository.repository.length) {
            country = element.id ? CountriesRepository.repository.get(element.id) : null;
        }
        hotelOffer.country = country || new CountryFactory(element);
    }

    element = data.resort;
    if (typeof element !== 'undefined') {
        resort = resorts?.get(element);

        hotelOffer.resort = resort;
    }

    element = data.checkInDate;
    if (typeof element !== 'undefined' && hotelOffer.nights) {
        hotelOffer.checkInDate = element;
        hotelOffer.checkInDateRange = new DataProxy(() => {
            element = data.checkInDate;

            dateParts = element.split('-');

            return CheckInDateRangeFactory({
                from: element,
                to: new Date((new Date(dateParts[0], dateParts[1] - 1, dateParts[2])).getTime() + hotelOffer.nights * 3600 * 24 * 1000 + 3600 * 4 * 1000),
            });
        });
    }

    element = data.touristGroup;
    if (typeof element !== 'undefined') {
        hotelOffer.touristGroup = element;
    }

    element = data.operator;
    if (typeof element !== 'undefined') {
        const operatorObj = element.id ? element : { id: element };
        hotelOffer.operator = OperatorsRepository.repository.add(operatorObj).toJSON() || null;
    }

    element = data.meal;
    if (typeof element !== 'undefined') {
        hotelOffer.meal = MealsRepository.repository.get(element) || element;
    }

    element = data.price;
    if (typeof element !== 'undefined') {
        hotelOffer.price = element;
    }

    element = data.discount;
    if (typeof element !== 'undefined') {
        hotelOffer.discount = element;
    }

    element = data.medicalInsurance;
    if (typeof element !== 'undefined') {
        hotelOffer.medicalInsurance = element;
    }

    element = data.hotel;
    if (typeof element !== 'undefined') {
        hotelOffer.hotel = element;
    }

    element = data.hotelAvailable;
    if (typeof element !== 'undefined') {
        hotelOffer.hotelAvailable = element;
    }

    element = data.cashbackAvailable;
    if (typeof element !== 'undefined') {
        hotelOffer.cashbackAvailable = element;
    }

    element = data.firstPaymentDefinition;
    if (typeof element !== 'undefined') {
        hotelOffer.firstPaymentDefinition = element;
    }

    element = data.room;
    if (typeof element !== 'undefined') {
        hotelOffer.room = element;
    }

    element = data.allFirstPaymentDefinitions;
    if (typeof element !== 'undefined') {
        hotelOffer.allFirstPaymentDefinitions = element;
    }

    element = data.maxHistoricalPrice;
    if (typeof element !== 'undefined') {
        hotelOffer.maxHistoricalPrice = element;
    }

    if (data.maxHistoricalPrice && data.price) {
        const { maxHistoricalPrice, price } = data;
        hotelOffer.originalPrice = maxHistoricalPrice;
        hotelOffer.discount = price < maxHistoricalPrice ? (1 - price / maxHistoricalPrice) : 0;
    }

    return new HotelOfferObjectValue(hotelOffer);
};

export default HotelOfferFactory;